import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type PublicGroupsState = {
    groups?: any[];
};

const initialState: PublicGroupsState = {
    groups: []
};

export const publicGroupsSlice = createSlice({
    name: 'publicGroups',
    initialState,
    reducers: {
        setPublicGroups: (state, action: PayloadAction<PublicGroupsState['groups']>) => {
            state.groups = action.payload;
        },
        clearPublicGroups: () => ({
            ...initialState
        })
    }
});

export const { setPublicGroups, clearPublicGroups } = publicGroupsSlice.actions;

export default publicGroupsSlice.reducer;
